var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFire(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2097_30713)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6029 8.89856C13.4717 5.95889 9.44407 5.80037 10.4168 1.52776C10.4888 1.21073 10.1502 0.965759 9.87637 1.13148C7.26093 2.67337 5.3804 5.76435 6.95831 9.81361C7.088 10.145 6.69893 10.4549 6.41793 10.2387C5.11381 9.25161 4.97691 7.83221 5.09219 6.81629C5.13542 6.44163 4.64548 6.2615 4.43653 6.57132C3.94658 7.32065 3.44943 8.5311 3.44943 10.354C3.72323 14.3888 7.13123 15.6281 8.3561 15.7866C10.1069 16.01 12.0019 15.6858 13.3636 14.4393C14.8623 13.0487 15.4099 10.8295 14.6029 8.89856ZM7.91659 12.5227C8.95412 12.2705 9.4873 11.5212 9.6314 10.8583C9.86917 9.82802 8.93971 8.81931 9.56655 7.19096C9.80432 8.53831 11.9226 9.38131 11.9226 10.8511C11.9803 12.674 10.0061 14.2375 7.91659 12.5227Z",
    fill: "#E06800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6029 8.89856C13.4717 5.95889 9.44407 5.80037 10.4168 1.52776C10.4888 1.21073 10.1502 0.965759 9.87637 1.13148C7.26093 2.67337 5.3804 5.76435 6.95831 9.81361C7.088 10.145 6.69893 10.4549 6.41793 10.2387C5.11381 9.25161 4.97691 7.83221 5.09219 6.81629C5.13542 6.44163 4.64548 6.2615 4.43653 6.57132C3.94658 7.32065 3.44943 8.5311 3.44943 10.354C3.72323 14.3888 7.13123 15.6281 8.3561 15.7866C10.1069 16.01 12.0019 15.6858 13.3636 14.4393C14.8623 13.0487 15.4099 10.8295 14.6029 8.89856ZM7.91659 12.5227C8.95412 12.2705 9.4873 11.5212 9.6314 10.8583C9.86917 9.82802 8.93971 8.81931 9.56655 7.19096C9.80432 8.53831 11.9226 9.38131 11.9226 10.8511C11.9803 12.674 10.0061 14.2375 7.91659 12.5227Z",
    fill: "#E06800"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2097_30713"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.2922,
    height: 17.2922,
    fill: "white",
    transform: "translate(0.567383)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFire);
export default __webpack_public_path__ + "static/media/Fire.68639fc887eb1c714a4bec8aa854f586.svg";
export { ForwardRef as ReactComponent };